const location = window.location.host;
const protocol = window.location.protocol;
export const ProfileItems = [
  {
    name: "Meu Perfil",
    icon: "home-alt",
    path: `${process.env.REACT_APP_AMEI}/realms/externo/account?referrer=planejadora-sebrae&referrer_uri=${protocol}//${location}`,
    target: true,
  },
  {
    name: "Minha Empresa",
    icon: "home-alt",
    path: `${process.env.REACT_APP_CPE}/?voltar=${protocol}//${location}`,
    target: true,
  },
  {
    name: "Alterar Senha",
    icon: "home-alt",
    path: `${process.env.REACT_APP_AMEI}/realms/externo/account/password?referrer=planejadora-sebrae`,
    target: true,
  },
];

export const MenuItems = [
  {
    id: 1,
    name: "Página inicial",
    icon: (
      <svg
        width="18"
        height="21"
        viewBox="0 0 18 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Página inicial</title>
        <g id="Group">
          <path
            id="Shape"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.9999 7.00049L10.9999 1.74049C9.86111 0.721918 8.13871 0.721918 6.99991 1.74049L0.999912 7.00049C0.357356 7.57516 -0.00694062 8.39848 -8.8145e-05 9.26049V18.0005C-8.8145e-05 19.6573 1.34306 21.0005 2.99991 21.0005H14.9999C16.6568 21.0005 17.9999 19.6573 17.9999 18.0005V9.25049C18.0039 8.39196 17.6398 7.57285 16.9999 7.00049ZM10.9999 19.0005H6.99991V14.0005C6.99991 13.4482 7.44763 13.0005 7.99991 13.0005H9.99991C10.5522 13.0005 10.9999 13.4482 10.9999 14.0005V19.0005ZM14.9999 19.0005C15.5522 19.0005 15.9999 18.5528 15.9999 18.0005V9.25049C15.9995 8.96327 15.8757 8.69006 15.6599 8.50049L9.65991 3.25049C9.2824 2.91885 8.71742 2.91885 8.33991 3.25049L2.33991 8.50049C2.12413 8.69006 2.00028 8.96327 1.99991 9.25049V18.0005C1.99991 18.5528 2.44763 19.0005 2.99991 19.0005H4.99991V14.0005C4.99991 12.3436 6.34306 11.0005 7.99991 11.0005H9.99991C11.6568 11.0005 12.9999 12.3436 12.9999 14.0005V19.0005H14.9999Z"
            fill="white"
          />
        </g>
      </svg>
    ),
    path: "/",
  },
  {
    id: 2,
    name: "Novo planejamento",
    icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Novo planejamento</title>
        <path
          id="novo-planejamento-driver-js"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 1H18C19.6569 1 21 2.34315 21 4V20C21 21.6569 19.6569 23 18 23H6C4.34315 23 3 21.6569 3 20V4C3 2.34315 4.34315 1 6 1ZM8 5H16C16.5523 5 17 5.44772 17 6V10C17 10.5523 16.5523 11 16 11H8C7.44772 11 7 10.5523 7 10V6C7 5.44772 7.44772 5 8 5ZM8.38 13.08C8.44143 13.1 8.49895 13.1304 8.55 13.17L8.71 13.29C8.89273 13.4816 8.99632 13.7352 9 14C8.99834 14.3326 8.83144 14.6426 8.55471 14.8271C8.27798 15.0116 7.92764 15.0464 7.62 14.92C7.49882 14.8694 7.3872 14.7983 7.29 14.71C7.10281 14.5213 6.99846 14.2658 7 14C6.99858 13.7283 7.10253 13.4667 7.29 13.27L7.44 13.15L7.62 13.06L7.8 13C7.92828 12.9701 8.06172 12.9701 8.19 13C8.25747 13.0155 8.32176 13.0426 8.38 13.08ZM12.55 17.17C12.6072 17.2046 12.6608 17.2448 12.71 17.29C12.801 17.3851 12.8724 17.4972 12.92 17.62C12.9712 17.7402 12.9984 17.8693 13 18C13.0015 18.2658 12.8972 18.5213 12.71 18.71C12.6128 18.7983 12.5012 18.8694 12.38 18.92C12.2613 18.976 12.1312 19.0034 12 19C11.7342 19.0015 11.4787 18.8972 11.29 18.71C11.202 18.6105 11.128 18.4995 11.07 18.38C11.0222 18.2591 10.9984 18.13 11 18C10.9966 17.8688 11.024 17.7387 11.08 17.62C11.1709 17.3688 11.3688 17.1709 11.62 17.08C11.7989 17.0005 11.9984 16.9795 12.19 17.02C12.2562 17.0293 12.3205 17.0496 12.38 17.08C12.4414 17.1 12.4989 17.1304 12.55 17.17ZM8.71 17.29C8.6149 17.199 8.50275 17.1276 8.38 17.08C8.19898 16.9961 7.99698 16.9682 7.8 17L7.62 17.06C7.55628 17.0819 7.49575 17.1122 7.44 17.15C7.38761 17.1869 7.33752 17.227 7.29 17.27C7.19896 17.3651 7.12759 17.4772 7.08 17.6C6.97302 17.842 6.97302 18.118 7.08 18.36C7.13064 18.4812 7.20167 18.5928 7.29 18.69C7.4754 18.8845 7.73129 18.9963 8 19C8.13118 19.0034 8.26132 18.976 8.38 18.92C8.50118 18.8694 8.6128 18.7983 8.71 18.71C8.79833 18.6128 8.86936 18.5012 8.92 18.38C9.02698 18.138 9.02698 17.862 8.92 17.62C8.87241 17.4972 8.80104 17.3851 8.71 17.29ZM11.29 13.29C11.3851 13.199 11.4972 13.1276 11.62 13.08C11.9924 12.9234 12.4224 13.0063 12.71 13.29C12.8927 13.4816 12.9963 13.7352 13 14C13.0015 14.2658 12.8972 14.5213 12.71 14.71C12.6128 14.7983 12.5012 14.8694 12.38 14.92C12.0724 15.0464 11.722 15.0116 11.4453 14.8271C11.1686 14.6426 11.0017 14.3326 11 14C11.0037 13.7352 11.1073 13.4816 11.29 13.29ZM16.71 17.29C16.6128 17.2017 16.5012 17.1306 16.38 17.08C16.0076 16.9234 15.5776 17.0063 15.29 17.29C15.199 17.3851 15.1276 17.4972 15.08 17.62C14.973 17.862 14.973 18.138 15.08 18.38C15.1306 18.5012 15.2017 18.6128 15.29 18.71C15.4787 18.8972 15.7342 19.0015 16 19C16.1312 19.0034 16.2613 18.976 16.38 18.92C16.5012 18.8694 16.6128 18.7983 16.71 18.71C16.9937 18.4224 17.0766 17.9924 16.92 17.62C16.8724 17.4972 16.801 17.3851 16.71 17.29ZM15 9H9V7H15V9ZM19 20C19 20.5523 18.5523 21 18 21H6C5.44772 21 5 20.5523 5 20V4C5 3.44772 5.44772 3 6 3H18C18.5523 3 19 3.44772 19 4V20ZM16.38 13.08C16.4414 13.1 16.4989 13.1304 16.55 13.17L16.71 13.29C16.8927 13.4816 16.9963 13.7352 17 14C17.0015 14.2658 16.8972 14.5213 16.71 14.71C16.6128 14.7983 16.5012 14.8694 16.38 14.92C16.0724 15.0464 15.722 15.0116 15.4453 14.8271C15.1686 14.6426 15.0017 14.3326 15 14C15.0037 13.7352 15.1073 13.4816 15.29 13.29L15.44 13.17L15.62 13.08L15.8 13.02C15.9283 12.9901 16.0617 12.9901 16.19 13.02C16.2562 13.0293 16.3205 13.0496 16.38 13.08Z"
          fill="#ffffff"
        />
      </svg>
    ),
    path: "/planejamento",
  },
  {
    id: 3,
    name: "Meus planejamentos",
    icon: (
      <svg
        id="meus-planejamentos-driver-js"
        width="20"
        height="22"
        viewBox="0 0 20 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Meus planejamentos</title>
        <g id="Group">
          <path
            id="Shape"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.50001 13.0606L0.500012 7.86062C0.192468 7.68306 0.00215571 7.35573 1.22535e-05 7.00062C-0.00141175 6.64193 0.189378 6.30996 0.500012 6.13062L9.50001 0.940615C9.80941 0.761982 10.1906 0.761982 10.5 0.940615L19.5 6.13062C19.8106 6.30996 20.0014 6.64193 20 7.00062C19.9979 7.35573 19.8076 7.68306 19.5 7.86062L10.5 13.0606C10.1906 13.2392 9.80941 13.2392 9.50001 13.0606ZM17 7.00062L10 3.00062L3.00001 7.00062L10 11.0006L17 7.00062ZM18.5 10.1706L10 15.0006L1.50001 10.1306C1.26949 9.99707 0.995206 9.96103 0.738009 10.0305C0.480811 10.1 0.261963 10.2692 0.130012 10.5006C-0.141376 10.9786 0.0238759 11.586 0.500012 11.8606L9.50001 17.0606C9.80941 17.2392 10.1906 17.2392 10.5 17.0606L19.5 11.8606C19.9761 11.586 20.1414 10.9786 19.87 10.5006C19.7381 10.2692 19.5192 10.1 19.262 10.0305C19.0048 9.96103 18.7305 9.99707 18.5 10.1306V10.1706ZM10 19.0006L18.5 14.1706V14.1306C18.7305 13.9971 19.0048 13.961 19.262 14.0305C19.5192 14.1 19.7381 14.2692 19.87 14.5006C20.1414 14.9786 19.9761 15.586 19.5 15.8606L10.5 21.0606C10.1906 21.2392 9.80941 21.2392 9.50001 21.0606L0.500012 15.8606C0.0238759 15.586 -0.141376 14.9786 0.130012 14.5006C0.261963 14.2692 0.480811 14.1 0.738009 14.0305C0.995206 13.961 1.26949 13.9971 1.50001 14.1306L10 19.0006Z"
            fill="white"
          />
        </g>
      </svg>
    ),
    path: "/meus-planejamentos",
  },
  {
    id: 4,
    name: "Como utilizar?",
    icon: (
      <svg
        id="como-utilizar-driver-js"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Como utilizar?</title>
        <g id="Group">
          <path
            id="Shape"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.0001 0.869145C18.7274 0.872125 19.4533 0.935678 20.1701 1.05914C20.6333 1.13854 20.9786 1.52972 21.0001 1.99915V13.9991C21.0044 14.2966 20.8761 14.5806 20.6499 14.7739C20.4238 14.9672 20.1233 15.0498 19.8301 14.9991C16.9201 14.5293 13.9438 15.258 11.5801 17.0191L11.4601 17.0891H11.3501C11.1261 17.1825 10.8741 17.1825 10.6501 17.0891H10.5401L10.4201 17.0191C8.0399 15.2966 5.06512 14.6079 2.17009 15.1091C1.87691 15.1598 1.57642 15.0772 1.35026 14.8839C1.1241 14.6906 0.995753 14.4066 1.00009 14.1091V2.10914C0.992933 1.61697 1.34501 1.19277 1.83009 1.10914C2.54689 0.985678 3.27274 0.922125 4.00009 0.919145C6.47674 0.902176 8.90624 1.59632 11.0001 2.91914C13.0886 1.57872 15.5185 0.86711 18.0001 0.869145ZM4.00009 12.8691C6.09061 12.8679 8.14997 13.3758 10.0001 14.3491V4.66915C8.2203 3.49284 6.13347 2.86679 4.00009 2.86914C3.66703 2.84995 3.33315 2.84995 3.00009 2.86914V12.8691H4.00009ZM19.0001 12.9091H18.0001C15.9096 12.9079 13.8502 13.4158 12.0001 14.3891V4.66915C13.7799 3.49284 15.8667 2.86679 18.0001 2.86914C18.3331 2.84995 18.667 2.84995 19.0001 2.86914V12.9091ZM18.0001 16.8691C18.7274 16.8721 19.4533 16.9357 20.1701 17.0591C20.433 17.1009 20.6684 17.2457 20.8242 17.4616C20.98 17.6774 21.0433 17.9465 21.0001 18.2091C20.8943 18.7498 20.3711 19.1031 19.8301 18.9991C16.9351 18.4979 13.9603 19.1866 11.5801 20.9091C11.2329 21.1563 10.7673 21.1563 10.4201 20.9091C8.0399 19.1866 5.06512 18.4979 2.17009 18.9991C1.62906 19.1031 1.10589 18.7498 1.00009 18.2091C0.956868 17.9465 1.02016 17.6774 1.17596 17.4616C1.33175 17.2457 1.56717 17.1009 1.83009 17.0591C2.54689 16.9357 3.27274 16.8721 4.00009 16.8691C6.48172 16.8671 8.9116 17.5787 11.0001 18.9191C13.0886 17.5787 15.5185 16.8671 18.0001 16.8691Z"
            fill="white"
          />
        </g>
      </svg>
    ),
    path: "/como-utilizar",
  },
  {
    id: 5,
    name: "Conteúdo",
    icon: (
      <svg
        id="content-driver-js"
        width="18"
        height="20"
        viewBox="0 0 18 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Conteúdo</title>
        <g id="Group">
          <path
            id="Shape"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.2899 1.71017C16.4777 1.89948 16.7333 2.00596 16.9999 2.00596C17.2666 2.00596 17.5222 1.89948 17.7099 1.71017C17.7983 1.61297 17.8693 1.50135 17.9199 1.38017C17.9712 1.25994 17.9983 1.13084 17.9999 1.00017C18.0015 0.734364 17.8971 0.478886 17.7099 0.290167L17.5599 0.170167C17.5042 0.13232 17.4436 0.102055 17.3799 0.0801667C17.0075 -0.07643 16.5775 0.00642216 16.2899 0.290167C16.1027 0.478886 15.9984 0.734364 15.9999 1.00017C16.0015 1.13084 16.0287 1.25994 16.0799 1.38017C16.1306 1.50135 16.2016 1.61297 16.2899 1.71017ZM16.9999 3.00017C16.4476 3.00017 15.9999 3.44788 15.9999 4.00017V8.00017C15.9999 8.55245 16.4476 9.00017 16.9999 9.00017C17.5522 9.00017 17.9999 8.55245 17.9999 8.00017V4.00017C17.9999 3.44788 17.5522 3.00017 16.9999 3.00017ZM15.9499 11.8702C16.0176 11.3242 16.5136 10.9355 17.0599 11.0002C17.3241 11.0326 17.5645 11.169 17.7278 11.3793C17.8911 11.5895 17.9638 11.8561 17.9299 12.1202C17.3653 16.6224 13.5374 20.0001 8.99992 20.0002H0.999923C0.596221 19.9982 0.233326 19.7536 0.0799226 19.3802C-0.0766741 19.0078 0.00617802 18.5777 0.289923 18.2902L1.99992 16.6202C-0.1568 13.9225 -0.579526 10.2286 0.911991 7.11348C2.40351 3.99834 5.54614 2.01152 8.99992 2.00017C10.5787 1.9986 12.129 2.41986 13.4899 3.22017C13.9046 3.52178 14.024 4.08821 13.7663 4.53153C13.5085 4.97485 12.9572 5.15136 12.4899 4.94017C11.4306 4.32275 10.2261 3.99831 8.99992 4.00017C6.16413 3.9959 3.60593 5.70297 2.52147 8.32322C1.437 10.9435 2.04055 13.9591 4.04992 15.9602C4.43765 16.3502 4.43765 16.9801 4.04992 17.3702L3.40992 18.0002H8.99992C12.5311 18.0023 15.511 15.374 15.9499 11.8702Z"
            fill="white"
          />
        </g>
      </svg>
    ),
    path: "/conteudo",
  },
  {
    id: 6,
    name: "Tutorial da Planejadora",
    icon: (
      <svg
        id="tutorial-driver-js"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Tutorial Planejadora</title>
        <path
          d="M4.00097 21.1667C4.00097 21.6267 4.3743 22 4.8343 22H16.6699C17.9621 22 18.4454 21.5944 18.4454 20.2222V18.6167M4.00097 21.1667C4.00097 20.5036 4.26436 19.8677 4.7332 19.3989C5.20204 18.9301 5.83793 18.6667 6.50097 18.6667H17.781C18.0321 18.6667 18.2536 18.65 18.4454 18.6167M4.00097 21.1667V5.55556C4.00097 4.29333 3.92097 2.90111 5.2143 2.24222C5.68986 2 6.31208 2 7.55653 2H17.7787C19.1521 2 19.5565 2.48556 19.5565 3.77778V16.8889C19.5565 17.9944 19.2432 18.4722 18.4454 18.6167"
          stroke="white"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.1122 14.2234C15.1122 9.93336 8.44556 9.93336 8.44556 14.2234"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.7789 10.8898C12.3682 10.8898 12.9335 10.6556 13.3502 10.2389C13.767 9.82214 14.0011 9.2569 14.0011 8.66753C14.0011 8.07816 13.767 7.51293 13.3502 7.09619C12.9335 6.67944 12.3682 6.44531 11.7789 6.44531C11.1895 6.44531 10.6243 6.67944 10.2075 7.09619C9.79077 7.51293 9.55664 8.07816 9.55664 8.66753C9.55664 9.2569 9.79077 9.82214 10.2075 10.2389C10.6243 10.6556 11.1895 10.8898 11.7789 10.8898Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
];

export const Companies = [
  {
    id: "7ab88003-361a-48c6-8ad5-d0321bd3fd09",
    name: "Empresa 2",
    cnpj: "XXX. XXX/0001-XX",
    date: "XX/XX/XXXX",
  },
  {
    id: "7ab88003-361a-48c6-8ad5-d0521bd3fd09",
    name: "Empresa 1",
    cnpj: "XXX. XXX/0001-XX",
    date: "XX/XX/XXXX",
  },
  {
    id: "0dda1546-c256-4745-996a-58a869747fef",
    name: "Empresa 3",
    cnpj: "XXX. XXX/0001-XX",
    date: "XX/XX/XXXX",
  },
];

export const Pills = [
  { id: "ID-2D9F6B7A", type: "video", content: "vid" },
  { id: "ID-A5C3E8D1", type: "image", content: "img" },
  { id: "ID-7B4E1F9C", type: "image", content: "new-img" },
  { id: "ID-1K434DC2", type: "video", content: "new" },
  { id: "ID-1K4dsC2", type: "video", content: "new" },
  { id: "ID-1K4d3432", type: "video", content: "new" },
  { id: "ID-13213432", type: "image", content: "new" },
  { id: "ID-1321vfewd32", type: "image", content: "new" },
  { id: "ID-13sadewd32", type: "video", content: "new" },
  { id: "ID-1234sadewd32", type: "video", content: "new" },
];
